/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tenant-integration-endpoint-attribute.reducer';

export const TenantIntegrationEndpointAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tenantIntegrationEndpointAttributeEntity = useAppSelector(state => state.tenantIntegrationEndpointAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="tenantIntegrationEndpointAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.detail.title">
            TenantIntegrationEndpointAttribute
          </Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.id">Id</Translate>
            </span>
            <UncontrolledTooltip target="id">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.id" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.id}</dd>
          <dt>
            <span id="value">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.value">Value</Translate>
            </span>
            <UncontrolledTooltip target="value">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.value" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.value}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.valueType">Value Type</Translate>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.valueType ? tenantIntegrationEndpointAttributeEntity.valueType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.tenantIntegrationEndpointAttribute.valueRange">Value Range</Translate>
          </dt>
          <dd>{tenantIntegrationEndpointAttributeEntity.valueRange ? tenantIntegrationEndpointAttributeEntity.valueRange.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/tenant-integration-endpoint-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/tenant-integration-endpoint-attribute/${tenantIntegrationEndpointAttributeEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default TenantIntegrationEndpointAttributeDetail;
